import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pptist-editor" }
const _hoisted_2 = { class: "layout-content" }
const _hoisted_3 = {
  class: "layout-content-center",
  ref: "layoutCenterRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Thumbnails = _resolveComponent("Thumbnails")!
  const _component_CanvasTool = _resolveComponent("CanvasTool")!
  const _component_Canvas = _resolveComponent("Canvas")!
  const _component_Remark = _resolveComponent("Remark")!
  const _component_ExportDialog = _resolveComponent("ExportDialog")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Thumbnails, { class: "layout-content-left" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CanvasTool, {
            class: "center-top",
            ref: "CanvasToolRef"
          }, null, 512),
          _createVNode(_component_Canvas, {
            class: "center-body",
            style: _normalizeStyle({ height: `calc(100% - ${_ctx.remarkHeight + 10}px)` })
          }, null, 8, ["style"]),
          (_ctx.showRemark)
            ? (_openBlock(), _createBlock(_component_Remark, {
                key: 0,
                class: "center-bottom",
                height: _ctx.remarkHeight,
                "onUpdate:height": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.remarkHeight) = $event)),
                style: _normalizeStyle({ height: `${_ctx.remarkHeight}px` })
              }, null, 8, ["height", "style"]))
            : _createCommentVNode("", true)
        ], 512)
      ])
    ]),
    _createVNode(_component_Modal, {
      visible: !!_ctx.dialogForExport,
      footer: null,
      centered: "",
      closable: false,
      width: 680,
      destroyOnClose: "",
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeExportDialog()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ExportDialog)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}